import { render, staticRenderFns } from "./asignaturas_x_docente.vue?vue&type=template&id=a9360020&scoped=true"
import script from "./asignaturas_x_docente.vue?vue&type=script&lang=js"
export * from "./asignaturas_x_docente.vue?vue&type=script&lang=js"
import style0 from "./asignaturas_x_docente.vue?vue&type=style&index=0&id=a9360020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9360020",
  null
  
)

export default component.exports